$(document).ready(function () {
  var locale = 'en';
  if ($('input[name="locale_code"]')) {
    locale = $('input[name="locale_code"]').val();
  }
  $('variant-radios').trigger('change');

  // -------------------------------------------------------------------------------
  // ------------------------------- GENERAL ONLOAD STUFF --------------------------
  // -------------------------------------------------------------------------------
  // Check if there is a hash in the URL
  if (window.location.hash.indexOf("#desktop") > -1) {
    // Remove the hash by updating the URL without reloading the page
    history.replaceState(null, null, window.location.pathname);
    //  console.log('Removed #desktop-1 from URL');
  }

  // nav menu
  $('[id^="Details-HeaderMenu-"]')
    .on("mouseover", function () {
      $(this).attr("open", true);
    })
    .on("mouseout", function () {
      $(this).attr("open", false);
    });

  //update pagination links to include url filter params
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.delete("page");
  $(".pagination__item").each(function () {
    var newURL = $(this).attr("href") + "&" + searchParams;
    $(this).attr("href", newURL);
  });

  $(".collection-list__item").on("click", function () {
    $(this).find("a").trigger("click");
  });

  // for product cards with swatches. on hovering the swatch, change the main image to match it
  $(".swatch-link img").on("mouseover", function () {
    var variantID = $(this).attr("variant-id");
    var productID = $(this).attr("product-id");
    var thisMedia = $(".media[product-id=" + productID + "]");
    thisMedia.children(".swatch-main-image").each(function () {
      if ($(this).attr("variant-id") == variantID) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  var windowWidth = $(window).width();
  if (windowWidth < 768) {
    $(".slider-button").attr("data-step", 1);
  }

  if ($('.sf-free-shipping-achieved').length > 0) {
    $('.sf-free-shipping-alert').hide();
  }


  // -------------------------------------------------------------------------------
  // ------------------------------ BUILD CUSTOM SAMPLE BOX ------------------------
  // -------------------------------------------------------------------------------

  var sample_color_count = 0;
  // select sample colors
  $('.sample-select').on('click',function() {
    console.log(sample_color_count);
    const thisCheckbox = $(this).find('input');
    if (thisCheckbox.prop('checked') == false) {
      if (sample_color_count < 5) {
        $(this).find('input').prop('checked',true).css('visibility','visible');
        sample_color_count = sample_color_count + 1;
      }
    } else {
      $(this).find('input').prop('checked',false).css('visibility','hidden');
      sample_color_count = sample_color_count - 1;
    }

    var colors_string = '';
    $('.sample-color-checkbox:checked').each(function() {
      if (colors_string.length > 0) {
        colors_string = colors_string + ', ';
      }
      colors_string = colors_string + $(this).val();
    });
  
    $('#sample-colors-input').val(colors_string);
  });

  // select sample box product
  $("#product-select").on('change',function() {
    const productId = $(this).val();
    const samplesGrid = $(`.samples-select-grid[data-id='${productId}']`);
    const sampleBoxId = samplesGrid.attr('data-sample-box-id');
    const sampleBoxSku = samplesGrid.attr('data-sample-box-sku');

    $('.samples-select-grid').addClass('hidden');
    samplesGrid.removeClass('hidden');

    $(`input[name='id']`).attr('value',sampleBoxId);
    $(`input[name='sku']`).attr('value',sampleBoxSku);

    $('.sample-color-checkbox').prop('checked',false);
    $('#sample-colors-input').val('');
    sample_color_count = 0;

    const productUrl = $('option:selected', this).attr('data-url');
    $('.view-product').attr('href',productUrl);
  });

  // -------------------------------------------------------------------------------
  // ------------------------------ INSPIRATION GALLERY ----------------------------
  // -------------------------------------------------------------------------------
  $('.inspiration-column img').on('click',function() {
      const imgPosition = $(this).attr('image-position');
      $(this).closest('.inspiration-column').siblings('.modal-overlay').show();
      $(this).siblings('.modal-overlay-window').show();
      $('img[image-position='+imgPosition+']').show();
  });

  $('.modal-overlay').on('click',function(e) {
    if (e.target == this) {
      $('.modal-overlay').hide();
      $('.modal-overlay-window img').hide();
    }
  });

  $('.gallery-next').click(function(e) {
    e.preventDefault();
    const window = $(this).closest('.modal-overlay-window').children('div');
    const imageCount = window.children('img').length;
    const currentImagePosition = parseInt(window.find('img:visible').attr('image-position'));
    var nextImagePosition = 0;
    if (currentImagePosition != imageCount - 1) {
      nextImagePosition = currentImagePosition + 1;
    }
    // console.log('image count: '+imageCount+', current: '+currentImagePosition+', next: '+nextImagePosition);
    window.find('img').hide();
    var nextImage = window.find('img[image-position='+nextImagePosition+']');
    nextImage.show();
    $('.gallery-alt-text').html(nextImage.attr('alt'));

  });

  $('.gallery-prev').click(function(e) {
    e.preventDefault();
    const window = $(this).closest('.modal-overlay-window').children('div');
    const imageCount = window.children('img').length;
    const currentImagePosition = parseInt(window.find('img:visible').attr('image-position'));
    var prevImagePosition = imageCount - 1;
    if (currentImagePosition != 0) {
      prevImagePosition = currentImagePosition - 1;
    }
    window.find('img').hide();
    var prevImage = window.find('img[image-position='+prevImagePosition+']');
    prevImage.show();
    $('.gallery-alt-text').html(prevImage.attr('alt'));

  });

  $('.modal-overlay-close').click(function() {
    $('.modal-overlay').hide();
    $('.modal-overlay-window img').hide();
  })

  // -------------------------------------------------------------------------------
  // ------------------------------- PRODUCT PAGE STUFF ----------------------------
  // -------------------------------------------------------------------------------

  // Match thumbnail alt text on variant names, to determine for which variants each thumbnail displays
  // Liquid cannot do regex so js has to do this
  $(".thumbnail").each(function () {
    var thisSrc = $(this).find('img').attr('src');
    var srcRegex = new RegExp("_skus([0-9-]+)",'g');
    const skuMatches = thisSrc.matchAll(srcRegex);
    var thisSkuList = "";
    for (const match of skuMatches) {
      thisSkuList = thisSkuList + match[1];
    }
    
    var thisAlt = $(this).find("img").attr("alt") || ""; // Handle undefined alt text

    // (PIN) in the alt text means display this image for all variants
    if (thisAlt.includes("(PIN)")) {
      $(this).parent().attr("data-sku", "all");
      $(this).parent().show();
      return; // Skip further checks for this image
    }

    
    $(this).parent().attr("data-sku", thisSkuList);

  });


  $('.shipping-estimate-message').each(function() {
    if ($(this).find('.countdown-to-shipping-cutoff') != null) {
      const today = new Date();
      const oneOClock = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 13, 0, 0).getTime();
      const $this = $(this);
      setInterval(function() {
        var current = new Date().getTime();
        var diff = oneOClock - current;
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = "0" + Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = "0" + Math.floor((diff % (1000 * 60)) / 1000);
        $this.find('span.countdown-to-shipping-cutoff').text(hours+":"+minutes.substr(minutes.length-2)+":"+seconds.substr(seconds.length-2));
      },1000);
    }
  });

  // "sale ends in..." countdown
  $('.sale-countdown').each(function() {
    const $this = $(this);
    const endDate = Date.parse($(this).text());
    var diff = endDate - Date.now() + new Date().getTimezoneOffset() * 60 * 1000;
    if (diff > 0) {
      const oneDay = 86400000;
      if (diff > oneDay) {
        if (diff < oneDay * 2) {
          const diffHours = Math.floor(diff / (1000 * 60 * 60));
          $(this).html("— Sale ends in <b>"+diffHours+" hours!</b>");
          $(this).css('visibility','visible');
        } else {
          const diffDays = Math.floor(diff / oneDay);
          $(this).html("— Sale ends in <b>"+diffDays+" days!</b>");
          $(this).css('visibility','visible');
        }
      } else {
        
        setInterval(function() {
          diff = endDate - Date.now()  + new Date().getTimezoneOffset() * 60 * 1000;
          const remainingHours = Math.floor((diff / (1000 * 60 * 60)) % 24);
          const remainingMinutes = "0" + Math.floor((diff / (1000 * 60)) % 60);
          const remainingSeconds = "0" + Math.floor((diff / 1000) % 60);
          $this.html("— sale ends in <b>"+remainingHours+":" + remainingMinutes.substr(remainingMinutes.length-2)+ ":" + remainingSeconds.substr(remainingSeconds.length-2) +"!</b>");
          $this.css('visibility','visible');
        }, 1000);
      }
    }
  });



  // -------------------------------- PRODUCT PAGE EXPAND/COLLAPSE CONTENT----------------------------------

  var selectedVariant = $(".selected-product-variant").attr("value");
  $("#tabs .des-content:not(#tabs-4)").each(function () {
    var contentWrapper = $(this);
    var contentHeight = contentWrapper.height();

    if (contentHeight > 500) {
      var details = "Expand details";
      var specs = "Expand specs";
      if (locale == 'fr') {
        details = "Afficher plus de détails";
        specs = "Afficher plus de spécifications";
      }
      contentWrapper.css("max-height", "500px").css("overflow", "hidden"); // Ensure content is hidden initially
      var expandButton = $("<button>").addClass("expand-button collapsed").text(details);
      var expandWrapper = $("<div>").addClass("expand-wrapper").append(expandButton);
      contentWrapper.after(expandWrapper);

      $(".pro-spec + div .expand-button").text(specs);
    }
  });

  $(document).on("click", "#tabs .expand-button", function (event) {
    var contentWrapper = $(this).closest(".expand-wrapper").prev(".des-content");
    // console.log(contentWrapper.attr("style"));
    var button = $(this);

    if (button.hasClass("collapsed")) {
      var details = "Collapse details";
      var specs = "Collapse specs";
      if (locale == 'fr') {
        details = "Masquer les détails";
        specs = "Masquer les spécifications";
      }
      button.removeClass("collapsed").text(details);
      contentWrapper.addClass("expanded").css("max-height", "none").css("overflow", "visible");
      $(".pro-spec.expanded + div .expand-button").text(specs);
    } else {
      var details = "Expand details";
      var specs = "Expand specs";
      if (locale == 'fr') {
        details = "Afficher plus de détails";
        specs = "Afficher plus de spécifications";
      }
      button.addClass("collapsed").text(details);
      contentWrapper.removeClass("expanded").css("max-height", "500px").css("overflow", "hidden");
      $(".pro-spec + div .expand-button").text(specs);
    }
  });

  // ----------------------------- PRODUCT MEDIA GALLERY ------------------------------------

  $("body").on(
    "click",
    ".fancybox-container .custom-fancy-button",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      // console.log('fancyb');
      // Get the Fancybox instance
      var fancyboxInstance = $.fancybox.getInstance();
      if (!fancyboxInstance) return;
      var originalTotal = parseInt($("span[data-fancybox-count]").text());
      var currentIndex = parseInt($("span[data-fancybox-index]").text()) - 1; // Current index within Fancybox

      var totalIndex = originalTotal; // Total slides in Fancybox
      var buttonClass = $(this).attr("class"); // Button class to determine direction
      var newIndex = currentIndex; // Initialize newIndex

      // Determine new index based on button direction
      if (buttonClass.includes("right")) {
        if (currentIndex + 1 === originalTotal) {
          newIndex = 0;
        } else {
          newIndex = currentIndex + 1;
        }
      } else {
        if (currentIndex === 0) {
          newIndex = originalTotal - 1;
        } else {
          newIndex = currentIndex - 1;
        }
      }
      // console.log('my new index is ' + newIndex);
      // Get the new thumbnail element and find the associated large image
      var $thumbnail = $(".thumbnail-list__item:visible").eq(newIndex);
      var targetId = $thumbnail.attr("data-target"); // Get the target ID for the large image
      // console.log("targetID " + targetId);
      // Find the corresponding large image container using the target ID
      var $largeImageContainer = $('li[data-media-id="' + targetId + '"]');
      var newImgSrc = $largeImageContainer.attr("data-src"); // Get the large image source from data-src attribute

      if (!newImgSrc) {
        console.error("Large image source not found for index:", newIndex);
        return;
      }
      // console.log('New large image source:', newImgSrc);

      // Update the image in the current Fancybox slide to the new large image source
      var $image = fancyboxInstance.current.$content.find(".fancybox-image");
      $image.attr("src", newImgSrc);

      // Wait for the image to load to get its intrinsic dimensions
      $image.on("load", function () {
        // Get the natural dimensions of the image
        var naturalWidth = this.naturalWidth;
        var naturalHeight = this.naturalHeight;

        // Update the Fancybox content size
        fancyboxInstance.current.$content.css({
          width: naturalWidth + "px",
          height: naturalHeight + "px",
          transform: "translate(-50%, -50%)",
        });

        // Update Fancybox's internal width and height properties
        fancyboxInstance.current.width = naturalWidth;
        fancyboxInstance.current.height = naturalHeight;

        // Trigger a recalculation of Fancybox layout
        fancyboxInstance.update();
      });

      // Update indices displayed
      $(this).parent().parent().parent()
        .find("span[data-fancybox-index]")
        .text(newIndex + 1);
      $("span[data-fancybox-count]").text(originalTotal);
    }
  );

  $("body").on("click", ".product__media-zoom-lightbox", function () {
    // first we count total relevant thumbnails and replace that in the index
    var thumbnailCount = 0;
    var activeIndex;
    $(".thumbnail-list__item").each(function () {
      var display = $(this).css("display");
      if (display === "none") {
        // we dont count nones
      } else {
        thumbnailCount++;
        var aria_current = $(this).find("button").attr("aria-current");
        if (aria_current === "true") {
          activeIndex = thumbnailCount;
        }
      }
    });
    // we also need to find the relevant index of this so we can replace the first number as well

    setTimeout(function () {
      $("span[data-fancybox-index]").text(activeIndex);
      $("span[data-fancybox-count]").text(thumbnailCount);
      $(".fancybox-navigation").append(
        '<button class="fancybox-button fancybox-button--arrow_left custom-fancy-button"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path></svg></div></button><button class="fancybox-button fancybox-button--arrow_right custom-fancy-button"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path></svg></div></button>'
      );
    }, 50);
  });

  var template = $("product-info").attr("template-type").split("|");


  // ------------------------------------- ON CHANGE PRODUCT VARIANT --------------------------------------

  $("body").on("change", ".selected-product-variant", function () {

    //so the subtotal for the accessory products get updated
    $('.quantity__input[name="quantity"]').trigger("change");
  });

  // for accessory product list on product page
  $(".add-to-cart_checkbox").change(function (e) {
    const checkedProducts = $(".add-to-cart_checkbox:checked");
    var subtotal = 0;
    checkedProducts.each(function () {
      subtotal += parseFloat(
        $(this).closest(".card").find(".unformatted-price").text()
      );
    });

    const subtotalParts = subtotal.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2}).split(".");
    $("#accessory-products_final-price").html(
      '$<span class="whole-number">' + subtotalParts[0] + "</span>." + subtotalParts[1]);

    const numProductsChecked = $(".add-to-cart_checkbox:checked").length;
    $(".accessory-btn-txt").html("Add " + numProductsChecked + " Products to Cart");
    if (this.checked) {
      $(this).siblings('input[type="hidden"]').removeAttr("disabled");
    } else {
      $(this).siblings('input[type="hidden"]').attr("disabled", "disabled");
    }
  });

  $(".add-to-cart_checkbox__mobile").change(function (e) {
    const checkedProducts = $(".add-to-cart_checkbox__mobile:checked");
    var subtotal = 0;
    checkedProducts.each(function () {
      subtotal += parseFloat(
        $(this).closest(".accessory-card__mobile").find(".unformatted-price").text()
      );
    });

    const subtotalParts = subtotal.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2}).split(".");
    $("#accessory-products_final-price__mobile").html(
      '$<span class="whole-number">' + subtotalParts[0] + "</span>." + subtotalParts[1]);

    const numProductsChecked = $(".add-to-cart_checkbox__mobile:checked").length;
    $(".accessory-btn-txt").html("Add " + numProductsChecked + " Products to Cart");
    if (this.checked) {
      $(this).siblings('input[type="hidden"]').removeAttr("disabled");
    } else {
      $(this).siblings('input[type="hidden"]').attr("disabled", "disabled");
    }
  });

  // ------------------------------------- ON CHANGE QUANTITY -----------------------------------------------------

  //update prices on the bundled products list
  $('.quantity__input[name="quantity"]').on('change',function() {
    var quantity = parseInt($(this).val().replace(',',''));
    
    const variant_id = $('.selected-product-variant').val();
    const variant = $('.pricing-list[variant-id="'+variant_id+'"]');
    const regular_price = parseFloat(variant.attr('variant-price').replace(',',''));

    //update the price for the "this item" bundle product
    var recalculated_price = regular_price * quantity;
    $(".main-product-card_for_accessory-products").find(".unformatted-price").html(recalculated_price);
    // console.log('regular price '+regular_price+' quantity '+quantity);
    recalculated_price_str = recalculated_price.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2});
    
    var formatted_price =
      "$<span class='whole-number'>" +
      recalculated_price_str.split(".")[0] +
      "</span>." +
      recalculated_price_str.split(".")[1];
    $(".main-product-card_for_accessory-products")
      .find(".now-price")
      .html(formatted_price);

    const checkedProducts = $(".add-to-cart_checkbox:checked");
    const checkedProductsMobile = $('.add-to-cart_checkbox__mobile:checked');

    var subtotal = 0;
    var subtotalMobile = 0;

    //go through each of the bundle products and add the prices to get the total
    checkedProducts.each(function () {
      subtotal += parseFloat($(this).closest(".card").find(".unformatted-price").text());
    });
    checkedProductsMobile.each(function () {
      subtotalMobile += parseFloat($(this).closest(".accessory-card__mobile").find(".unformatted-price").text());
    });

    const subtotalParts = subtotal.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2}).split(".");
    const subtotalPartsMobile = subtotalMobile.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2}).split(".");
    $("#accessory-products_final-price").html(
      '$<span class="whole-number">' + subtotalParts[0] + "</span>." + subtotalParts[1]);
    $("#accessory-products_final-price__mobile").html(
      '$<span class="whole-number">' + subtotalPartsMobile[0] + "</span>." + subtotalPartsMobile[1]);

  });

  //trigger the above on page load
  $('.quantity__input[name="quantity"]').trigger('change');




  // Detect if the user is on a mobile device
  const isMobile = window.innerWidth <= 768; // Adjust the width threshold as needed
  // console.log('i am mobile ' + isMobile);
  if (!isMobile) {
    // Select all labels with the class "color-label"
    document.querySelectorAll(".color-label").forEach((label) => {
      let hideTimeout;

      // Show the popup when hovering over the label
      label.addEventListener("mouseenter", () => {
        const popup = label.querySelector(".popup_data");
        const radioInput = label.previousElementSibling; // Select the radio button above the label

        // Show the popup
        popup.style.display = "block";
        popup.style.opacity = "1";

        // remove the popup when mouse over the popup. so the popup doesn't get in the way when user moves the mouse to a color in the row above
        popup.addEventListener("mouseenter", () => {
          popup.style.display = "none";
          popup.style.opacity = "1";
        });

        // Clear any existing hide timeout if they re-hover
        clearTimeout(hideTimeout);

        // Set a timeout to hide the popup after 3 seconds
        hideTimeout = setTimeout(() => {
          popup.style.opacity = "0";
          setTimeout(() => {
            popup.style.display = "none";
          }, 300); // Wait for the opacity transition to finish
        }, 2000); // Hide after 3 seconds
      });

      // Hide the popup immediately when the user hovers out
      label.addEventListener("mouseleave", () => {
        const popup = label.querySelector(".popup_data");

        // Clear the timeout so it doesn’t hide after 3 seconds
        clearTimeout(hideTimeout);

        // Hide the popup immediately
        popup.style.opacity = "0";
        setTimeout(() => {
          popup.style.display = "none";
        }, 300); // Wait for the opacity transition to finish
      });
    });
  }

  var addToCartForm = document.getElementById("addToCartForm");
  var sampleProductSubmitButton = document.getElementById(
    "sample-ProductSubmitButton"
  );
  var sampleProductSubmitButton1 = document.getElementById(
    "sample-ProductSubmitButton1"
  );
  var accessoryProductSubmitButton = document.getElementById(
    "accessory-ProductSubmitButton"
  );
  var accessoryProductSubmitButtonMobile = document.getElementById(
    "accessory-ProductSubmitButton__mobile"
  );
  var sampleBoxSubmitButton = document.getElementById("samplebox-ProductSubmitButton");

  function handleFormSubmission(event) {
    event.preventDefault();
    var formData = new FormData(event.currentTarget.form);

    for (const p of formData.entries()) {
      console.log(p);
    }


    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        // console.log(response.json());
        if (response.ok) {
          // for (var pair of formData.entries())
          // Change the text to indicate success
          //    console.log("response", response );

            fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                updates: {},
                sections: ["cart-drawer", "cart-icon-bubble"],
              }),
            })
              .then((res) => res.json())
              .then((cartData) => {
                document.querySelector("cart-drawer").renderContents(cartData);
                document
                  .querySelector("cart-drawer.drawer")
                  .classList.remove("is-empty");
              });
        } else {

          console.error("Failed to add product to cart:", response.statusText);
        }
      })
      .catch((error) => {

        console.error("Network error:", error);
      });
  }

  if (
    
    sampleProductSubmitButton &&
    sampleProductSubmitButton1
  ) {
    sampleProductSubmitButton.addEventListener("click", handleFormSubmission);
    sampleProductSubmitButton1.addEventListener("click", handleFormSubmission);
    sampleProductSubmitButton.addEventListener("touchstart",handleFormSubmission);
    sampleProductSubmitButton1.addEventListener("touchstart",handleFormSubmission);
    sampleProductSubmitButton.form = document.getElementById("addToCartFormSample");
    sampleProductSubmitButton1.form = document.getElementById("addToCartFormSample1");
  }

  if (sampleBoxSubmitButton) {
    sampleBoxSubmitButton.addEventListener("click",handleFormSubmission);
    sampleBoxSubmitButton.form = document.getElementById("addToCartFormSampleBox");
    formData = new FormData(sampleBoxSubmitButton.form);
  }
  if (accessoryProductSubmitButton) {
    accessoryProductSubmitButton.addEventListener("click",handleFormSubmission);
    accessoryProductSubmitButton.form = document.getElementById("addToCartAccessoryProducts");
    formData = new FormData(accessoryProductSubmitButton.form);
  }
  if (accessoryProductSubmitButtonMobile) {
    accessoryProductSubmitButtonMobile.addEventListener("click",handleFormSubmission);
    accessoryProductSubmitButtonMobile.form = document.getElementById("addToCartAccessoryProducts__mobile");
    formData = new FormData(accessoryProductSubmitButtonMobile.form);
  }

  var WindowHeight = jQuery(window).height();

  var load_element = 0;

  //position of element
  var scroll_position = jQuery(".des-section.w-bg .tab-links").offset().top;

  var screen_height = jQuery(window).height();
  var activation_offset = 0;
  var max_scroll_height = jQuery("body").height() + screen_height;

  var scroll_activation_point =
    scroll_position - screen_height * activation_offset;
  // var tab1 = jQuery('#tabs-1').offset().top;
  // var tab2 = jQuery('#tabs-2').offset().top;
  // var tab3 = jQuery('#tabs-3').offset().top;
  // var tab4 = jQuery('#tabs-4').offset().top;
  jQuery(window).on("scroll", function (e) {
    // if(!$('body').hasClass("stop-sticky")){
    var y_scroll_pos = window.pageYOffset;
    var element_in_view = y_scroll_pos > scroll_activation_point;
    var has_reached_bottom_of_page =
      max_scroll_height <= y_scroll_pos && !element_in_view;

    if (element_in_view || has_reached_bottom_of_page) {
      if (!jQuery(".des-section.w-bg .tab-links").hasClass("tab-sticky")) {
        jQuery(".des-section.w-bg .tab-links").addClass("tab-sticky");
        jQuery(".des-section.w-bg .tab-links").addClass(
          "tab-sticky-tab-active"
        );

        setTimeout(function () {
          let iid = jQuery(".tab-sticky li a.active").attr("href");
          if (iid != "" && iid !== undefined) {
            console.log(iid);
            iid = iid.replace("#", "");
            targetSectionid = document.getElementById(iid);
            if (jQuery("body").hasClass("clickontab")) {
              jQuery("html, body").animate({
                scrollTop:
                  targetSectionid.offsetTop -
                  document.querySelectorAll(".des-tab")[0].offsetHeight,
              });

              jQuery("body").removeClass("clickontab");
            }
          }
        }, 800);
      }
      // jQuery('.des-section.w-bg .tab-links').addClass("tab-sticky");
    } else {
      jQuery("body").removeClass("stop-sticky");
      jQuery(".des-section.w-bg .tab-links").removeClass("tab-sticky");
      jQuery(".des-section.w-bg .tab-links").removeClass(
        "tab-sticky-tab-active"
      );
    }
    // }
  });

  const tabs = document.querySelectorAll(".des-tab");
  const sections = document.querySelectorAll(".des-content");

  window.addEventListener("scroll", function () {
    if (!$("body").hasClass("stop-sticky")) {
      let fromTop = window.scrollY + 110;

      sections.forEach((section) => {
        if (
          section.offsetTop <= fromTop &&
          section.offsetTop + section.offsetHeight > fromTop
        ) {
          tabs.forEach((tab) => {
            if (tab.dataset.target === section.id) {
              tab.classList.add("active");
            } else {
              tab.classList.remove("active");
            }
          });
        }
      });
    }
  });

  tabs.forEach((tab) => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      jQuery("body").addClass("clickontab");

      document.querySelectorAll(".des-content").forEach((content) => {
        jQuery(content).removeClass("active");
      });

      const targetSection = document.getElementById(this.dataset.target);
      jQuery(targetSection).addClass("active");
      setTimeout(function () {
        jQuery("html, body").animate({
          scrollTop: targetSection.offsetTop - tabs[0].offsetHeight,
        });
      }, 200);

      tabs.forEach((t) => {
        jQuery(t).removeClass("active");
      });

      jQuery(this).addClass("active");
    });
  });

  // disable the order submit button if paint selected color is none
  $(".paint-custom-color").on("change", function () {
    var selection = $(this).val();
    if (selection == "none") {
      $(".button--primary").attr("disabled", "disabled");
      $(".button--primary > span").text("Select a color");
      $(".button--primary > b").text("Select a color");
    } else {
      $(".button--primary").removeAttr("disabled");
      $(".button--primary > span").text("Add to Cart");
      $(".button--primary > b").text("Add a Sample to Cart");
      if ($(".paint-custom-color").attr("sample") == "untinted") {
        $("#sample-ProductSubmitButton > b").text(
          "Add Untinted Sample to Cart"
        );
        $("#sample-ProductSubmitButton1 > b").text(
          "Add Untinted Sample to Cart"
        );
        $("#sample-ProductSubmitButton").removeAttr("disabled");
        $("#sample-ProductSubmitButton1").removeAttr("disabled");
      }
    }
  });

  $(".paint-custom-color-text").on("input", function () {
    var selection = $(this).val();
    if (selection == "") {
      $(".button--primary").attr("disabled", "disabled");
      $(".button--primary > span").text("Select a color");
      $(".button--primary > b").text("Select a color");
    } else {
      $(".paint-custom-color").val(selection);
      $(".button--primary").removeAttr("disabled");
      $(".button--primary > span").text("Add to Cart");
      $(".button--primary > b").text("Add a Sample to Cart");
      if ($(".paint-custom-color").attr("sample") == "untinted") {
        $("#sample-ProductSubmitButton > b").text(
          "Add Untinted Sample to Cart"
        );
        $("#sample-ProductSubmitButton1 > b").text(
          "Add Untinted Sample to Cart"
        );
        $("#sample-ProductSubmitButton").removeAttr("disabled");
        $("#sample-ProductSubmitButton1").removeAttr("disabled");
      }
    }
  });

  
});
